import { Box, Flex, Menu, Text } from '@mantine/core'
import { IconBell } from '@tabler/icons'
import React, { useEffect, useMemo } from 'react'
import AiCommentsSection from '../AiCommentsSection'
import { BusinessNameNotification, FillIconNotification } from '../../../../../icons/x-symbol-svgrepo-com'
import { useIdeaPage } from '../../../../../hooks/ideaPage'

const AiCommentsMenu = ({
  chosenEvidence: propChosenEvidence,
//   getUnreadNotificationsCountByRequest: propGetUnreadNotificationsCountByRequest
}: {
  chosenEvidence: any;
//   getUnreadNotificationsCountByRequest: (requestId: string) => number;
}) => {

  const parseQueryParams = (search: string) => {
    return new URLSearchParams(search);
  };
  const queryParams = parseQueryParams(location.search);
  const commentId = queryParams.get("commentId"); 
  // Use useIdeaPage hook for AI component data
  const aiIdeaData = useIdeaPage();

  // Extract data from useIdeaPage hook
  const {
    activityOpened,
    setActivityOpened,
    getUnreadNotificationsCountByRequest,
    comments
  } = aiIdeaData;

  const chosenEvidence = useMemo(() =>
    propChosenEvidence,
  [propChosenEvidence]
  );

  
  const commentExist = comments?.length > 0;
  
  // Use ref to track if commentId has been processed to prevent loop
  const commentIdProcessedRef = React.useRef(false);
  
  useEffect(() => {
    if (commentId && setActivityOpened && typeof setActivityOpened === 'function' && !commentIdProcessedRef.current) {
      setActivityOpened(true);
      commentIdProcessedRef.current = true;
    }
  }, [commentId]); // Remove setActivityOpened from dependencies
  
  return (
   
    <Menu opened={activityOpened || false} 
      position="left"
      closeOnItemClick={false}
      closeOnEscape={false}
      closeOnClickOutside={false}
      withinPortal={true}
      offset={38}
      styles={{
        dropdown: {
          zIndex: 9999,
          overflow: 'auto',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
          borderRadius: '12px',
          backgroundColor: 'white'
        }
      }}>
      <Menu.Target>
        <Flex align="center" w="107px" /* mr="12px" */ sx={{ cursor: "pointer" }}>
          <Box>
            {getUnreadNotificationsCountByRequest?.(chosenEvidence?._id) > 0 ? <BusinessNameNotification/> :  commentExist ? <FillIconNotification/> : <IconBell size={15} color="#5C5CEB" />}
          </Box>

          <Text ml="4px" fw={500} color="#5C5CEB" fz={12} lineClamp={1} onClick={()=>setActivityOpened && typeof setActivityOpened === 'function' ? setActivityOpened((prev: boolean)=> !prev) : null}>
                Activity
          </Text>
        </Flex>
      </Menu.Target>

      <Menu.Dropdown /* p={0} mb={0} */>
        <Box>
          <AiCommentsSection 
            item={chosenEvidence} 
            setOpened={setActivityOpened && typeof setActivityOpened === 'function' ? setActivityOpened : () => null} 
            componentType={"ai"} 
            commentId={commentId}/>
        </Box>
      </Menu.Dropdown>
    </Menu>
   
  )
}

export default AiCommentsMenu